/*
 * Copyright (c) Nexign, JSC, 2020-2023.
 */
/**
 * Guard TabMenu Access
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @author Evgeniy Naumov
 * @version 1.25.1
 * @since 1.0.0
 */

import { IAccess } from '@modules/role/types/guardTypes';
import { AuthorityRoleEnum, EUserType } from '@pages/PageAuth/constants/authConstants';

import { AccessComponentKeyEnum, FeatureNameEnum } from './guardConstants';

const TabMenuAccess: IAccess = {
    [AccessComponentKeyEnum.TabMenuAccount]: {},
    [AccessComponentKeyEnum.TabMenuService]: {},
    [AccessComponentKeyEnum.TabMenuServicesSubscriber]: {},
    [AccessComponentKeyEnum.TabMenuHistory]: {},
    [AccessComponentKeyEnum.TabMenuHistoryOrder]: {},
    [AccessComponentKeyEnum.TabMenuHistoryInquiry]: {},
    [AccessComponentKeyEnum.TabMenuMain]: {},
    [AccessComponentKeyEnum.TabMenuOffers]: {},
    [AccessComponentKeyEnum.TabMenuProducts]: {
        userTypeId: {
            isAllowed: false,
            id: [EUserType.SACS_ID_READONLY],
        },
    },
    [AccessComponentKeyEnum.TabMenuNews]: {
        featureName: FeatureNameEnum.NEWS,
        role: [AuthorityRoleEnum.ROLE_NEWS_SERVICE_USER],
    },

    // Menu items of PageSettings
    [AccessComponentKeyEnum.PageSettingsMenuAutoReports]: {
        role: [AuthorityRoleEnum.ROLE_PRIVILEGED_USER],
    },
    [AccessComponentKeyEnum.PageSettingsMenuLabels]: {
        role: [
            AuthorityRoleEnum.ROLE_COORDINATOR_USER,
            AuthorityRoleEnum.ROLE_TAGS_IMPORT,
        ],
    },
    [AccessComponentKeyEnum.PageSettingsMenuPositions]: {
        role: [AuthorityRoleEnum.ROLE_COORDINATOR_USER],
    },
    [AccessComponentKeyEnum.PageSettingsMenuStatistics]: {
        // https://jira.nexign.com/browse/BBPORTAL-9141
        role: [],
    },
};

export default TabMenuAccess;
